export default "__VITE_ASSET__c518952e__"